import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import DatePicker from '@afosto/app-components-react/DatePicker';
import Form from '@afosto/app-components-react/Form';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import validationSchema from './validations';
import translations from './translations';

const PaymentStatusForm = ({ invoice, onSubmit, onCancel, inline }) => {
  const intl = useIntl();
  const form = useForm({
    validationSchema,
    editInline: inline,
    defaultValues: {
      paidAt: invoice?.paid_at ?? null,
    },
    onSubmit,
    onCancel,
  });

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        <DatePicker
          name="paidAt"
          label={intl.formatMessage(translations.fields.paidAt.label)}
          style={{ marginTop: 16 }}
          disableFuture={false}
        />
      </Form>
    </LoadingWrapper>
  );
};

PaymentStatusForm.propTypes = {
  invoice: PropTypes.object,
  inline: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

PaymentStatusForm.defaultProps = {
  invoice: {},
  inline: false,
  onCancel: undefined,
  onSubmit: undefined,
};

export default PaymentStatusForm;
